import React, { useEffect, useState, useContext } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import axios from 'axios';
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  TextField,
  IconButton,
  Tooltip,
  Divider
} from "@material-ui/core";

import { CopyToClipboard } from "react-copy-to-clipboard";

import Alert from '@material-ui/lab/Alert';

import EditIcon from '@material-ui/icons/Edit';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';

import { PageContext } from "../../../contexts/PageContext";
import { UserContext } from "../../../contexts/UserContext";

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  addFieldsButton: {
    marginRight: 15
  }
}));

export default function RenameCreditDialog(
  {
    credit,
    setCredit
  }) {
  const theme = useTheme();
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState(credit.title);

  const pageContext = useContext(PageContext);
  const userContext = useContext(UserContext);

  const saveCreditTitle = () => {
    const saveData = { ...credit, title: title };
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/credits/${credit.id}`,
      data: saveData,
      method: 'put',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        pageContext.setInfoMessage("Finanzierung wurde umbenannt.");
        setCredit({ ...credit, title: title });
      })
      .catch((err) => {
        console.log(err);
        pageContext.setErrorMessage("Finanzierung konnte nicht umbenannt werden!");
      });
  }


  return (
    <>
      <Tooltip title="umbenennen">
        <IconButton
          color="primary"
          style={{ backgroundColor: "#ddd", marginLeft: 12 }}
          size="small"
          onClick={() => {
            setOpen(true);
          }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Dialog
        onClose={() => { setOpen(false) }}
        open={open}
        fullWidth={true}
        maxWidth="sm">
        <DialogTitle>
          Finanzierung umbenennen
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Titel"
            value={title}
            onChange={(e) => { setTitle(e.target.value) }}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button
            disabled={!title || title === credit.title}
            onClick={() => {
              saveCreditTitle();
              setOpen(false);
            }}
            color="primary"
            variant="contained"
            autoFocus>
            übernehmen
          </Button>
        </DialogActions>
      </Dialog >
    </>
  );
}
